module.exports = __webpack_public_path__ + "icon-perfil-user.png";